<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-19 17:08:40
 * @LastEditors: 诺
 * @LastEditTime: 2022-10-26 13:33:33
-->
<template>
  <div
    :class="['model', type, `${type}${config.uiExt.uiExtTemplate}`, theme]"
    v-if="data.length != 0"
    :style="model"
  >
    <div
      class="modelTitle"
      :style="{ backgroundColor: bColor, color: textColor }"
    >
      {{ title }}
    </div>
    <div class="modelBg">
      <div class="list">
        <div
          class="item"
          v-for="(item, index) in data"
          :key="index"
          @click="$emit('handleCoupon', item)"
        >
          <div class="itemMain" v-if="item.styleType == 1 && item.winType == 4">
            <div
              :class="[
                'itemInfo',
                type,
                `${type}${config.uiExt.uiExtTemplate}`,
              ]"
            >
              <div
                :class="[
                  'typeName',
                  type,
                  `${type}${config.uiExt.uiExtTemplate}`,
                ]"
              >
                {{ item.type == 4 ? "折扣" : "立减" }}
              </div>
              <div class="couponTitle">{{ item.name }}</div>
              <div
                :class="[
                  'couponInfo',
                  type,
                  `${type}${config.uiExt.uiExtTemplate}`,
                ]"
              >
                {{ item.info }}
              </div>
            </div>
            <div
              :class="[
                'itemIntro',
                type,
                `${type}${config.uiExt.uiExtTemplate}`,
              ]"
            >
              <div :class="['itemIntroBox', type,`${type}${config.uiExt.uiExtTemplate}`,] ">
                <div
                  :class="[
                    'reduce',
                    type,
                    `${type}${config.uiExt.uiExtTemplate}`,
                  ]"
                  v-if="item.type == 4"
                >
                  <span> {{ item.discount }}</span> 折
                </div>
                <div
                  :class="[
                    'reduce',
                    type,
                    `${type}${config.uiExt.uiExtTemplate}`,
                  ]"
                  v-if="item.type == 5"
                >
                  <span> {{ item.reduce }}</span
                  >元
                </div>
                <div
                  :class="[
                    'receive',
                    type,
                    `${type}${config.uiExt.uiExtTemplate}`,
                  ]"
                >
                  立即领取
                </div>
              </div>
            </div>
          </div>

          <div class="itemMain" v-if="item.styleType == 1 && item.winType == 5">
            <div
              :class="[
                'itemInfo',
                type,
                `${type}${config.uiExt.uiExtTemplate}`,
              ]"
            >
              <div class="couponTitle">{{ item.name }}</div>
              <div
                :class="[
                  'couponInfo',
                  type,
                  `${type}${config.uiExt.uiExtTemplate}`,
                ]"
                v-html="item.text"
              ></div>
            </div>
            <div
              :class="[
                'itemIntro',
                type,
                `${type}${config.uiExt.uiExtTemplate}`,
              ]"
            >
             <div :class="['itemIntroBox', type,`${type}${config.uiExt.uiExtTemplate}`,] ">
                <div
                  :class="[
                    'reduce',
                    type,
                    `${type}${config.uiExt.uiExtTemplate}`,
                  ]"
                >
                  ￥<span>{{ item.amount / 100 }}</span>
                </div>
                <div
                  :class="[
                    'receive',
                    type,
                    `${type}${config.uiExt.uiExtTemplate}`,
                  ]"
                >
                  一键锁定
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="itemMain" v-if="item.styleType == 2"  :style="{ backgroundImage: ` url(${item.img})` }"> -->
          <!-- <div class="itemMain" v-if="item.styleType == 2"  > -->
          <img v-if="item.styleType == 2" :src="item.img" />
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data", "bColor", "title", "textColor", "type", "theme"],
  data() {
    return {
      config: this.$configInfo,
    };
  },
  watch: {
    data: {
      handler(val) {
        val.map((item) => {
          item.text = (item.info||'').replace(/\n/g, "<br/>");
        });
      },
      deep: true,
    },
  },
  computed: {
    model() {
      if (this.type == "lightup") {
        return { backgroundColor: `${this.bColor}80` };
      } else if (this.type == "purchase") {
        return {};
      }
      if (this.theme == "theme2") {
        return {
          backgroundColor: this.$util.rgbToRgba(this.bColor, 0.5),
        };
      }
      return {
        borderColor: this.bColor,
      };
    },
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
img {
  width: 100%;
}
div {
  box-sizing: border-box;
}
.model {
  width: 351px;
  margin: 36px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border: 5px solid #fff;
  box-sizing: border-box;
  &.purchase {
    padding: 10px;
    border: none;
    margin: 25px auto 0;
    box-shadow: 0px 0px 12px rgba(172, 3, 40, 0.3);
    background: rgba(255, 255, 255, 0.1);
    .modelTitle {
      margin-top: -10px;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      border-radius: 0px 0px 12px 12px;
    }
  }
  &.theme2 {
    padding: 10px;
    border: none;
    margin: 25px auto 0;
    box-shadow: 0px 0px 12px rgba(172, 3, 40, 0.3);
    background: rgba(255, 255, 255, 0.1);
    .modelTitle {
      margin-top: -10px;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      border-radius: 0px 0px 12px 12px;
    }
  }

  .modelTitle {
    position: absolute;
    margin-top: -20px;
    // margin-top: -10px;
    color: white;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    // border-radius: 0px 0px 12px 12px;
    border-radius: 6px;
  }

  .modelBg {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 7px;

    .list {
      margin: 40px 15px 19px;

      .item {
        margin-bottom: 14px;

        .itemMain {
          min-height: 100px;
          // width: 311px;
          background-position: top center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          display: flex;

          .itemInfo {
            border-radius: 8px;
            width: 270px;
            padding: 29px 70px 29px 20px;
            box-sizing: border-box;
            height: 100%;
            min-height: 100px;
            display: flex;
            flex-direction: column;
            &.lucky, &.turntable,&.jiugongge,&.niudanji,&.zhuabaoxiang,&.laohuji{
              background: linear-gradient(
                180deg,
                #f89147 4.69%,
                #f0672e 44.27%,
                #e84424 83.33%
              );
              box-shadow: 0px 0px 8px rgba(142, 48, 27, 0.2),
                inset 0px -1px 0px rgba(166, 43, 17, 0.5),
                inset 0px 1px 0px rgba(255, 195, 158, 0.5);
              &3 {
                background: linear-gradient(180deg, #ffa96a 0%, #fe5555 75.52%);
                box-shadow: 0px 0px 8px rgba(241, 108, 78, 0.5),
                  inset 0px -1px 0px rgba(255, 176, 58, 0.7),
                  inset 0px 1px 0px rgba(255, 242, 173, 0.5);
              }
            }
            &.blindbox{
              background: linear-gradient(180deg, #f89147 4.69%, #f0672e 44.27%, #e84424 83.33%);
              box-shadow: 0px 0px 8px rgba(142, 48, 27, 0.2), inset 0px -1px 0px rgba(166, 43, 17, 0.5), inset 0px 1px 0px rgba(255, 195, 158, 0.5);
              &3 {
                background: linear-gradient(180deg, #ffa96a 0%, #fe5555 75.52%);
                box-shadow: 0px 0px 8px rgba(241, 108, 78, 0.5), inset 0px -1px 0px rgba(255, 176, 58, 0.7), inset 0px 1px 0px rgba(255, 242, 173, 0.5);
              }
              &4 {
                background: linear-gradient(180deg, #00BAC5 0%, #084F5F 100%);
                box-shadow: inset 0px 2px 2px rgba(255, 255, 255, 0.5);
              }
              &5 {
                background: linear-gradient(180deg, #AF5AFF 0%, #744AEC 75.52%);
                box-shadow: 0px 0px 8px rgba(99, 44, 255, 0.5), inset 0px -1px 0px rgba(95, 45, 237, 0.7), inset 0px 1px 0px rgba(234, 173, 255, 0.5);
              }
            }
            &.coupon,
            &.purchase {
              background: linear-gradient(180deg, #f28353 0%, #e14076 75.52%);
              box-shadow: 0px 0px 8px rgba(142, 48, 27, 0.2),
                inset 0px -1px 0px rgba(166, 43, 17, 0.5),
                inset 0px 1px 0px rgba(255, 195, 158, 0.5);
            }
            &.purchase0 {
              background: linear-gradient(180deg, #f28353 0%, #e14076 75.52%);
              box-shadow: 0px 0px 8px rgba(142, 48, 27, 0.2),
                inset 0px -1px 0px rgba(166, 43, 17, 0.5),
                inset 0px 1px 0px rgba(255, 195, 158, 0.5);
            }
            &.purchase1 {
              background: linear-gradient(
                137.26deg,
                #7ea2ff 24.01%,
                #b871ff 74.71%
              );
              box-shadow: 0px 0px 8px rgba(34, 11, 151, 0.2),
                inset 0px -1px 0px rgba(56, 17, 166, 0.5),
                inset 0px 1px 0px rgba(234, 218, 255, 0.5);
            }
            &.purchase2 {
              background: linear-gradient(180deg, #67d4f4 0%, #188ff2 75.52%);
              box-shadow: 0px 0px 8px rgba(24, 143, 242, 0.2),
                inset 0px -1px 0px #0873cc,
                inset 0px 1px 0px rgba(230, 255, 250, 0.5);
            }
            &.purchase3 {
              background: linear-gradient(348deg, #F52257 16.4%, #FE5555 93%);
              box-shadow: 0px 0px 8px rgba(241, 108, 78, 0.5), inset 0px -1px 0px rgba(255, 176, 58, 0.7), inset 0px 1px 0px rgba(255, 242, 173, 0.5);
            }
            &.assistance {
              background: linear-gradient(
                180deg,
                #c964f3 4.69%,
                #9700d9 44.27%,
                #7004a3 83.33%
              );
              box-shadow: 0px 0px 8px rgba(151, 0, 217, 0.3),
                inset 0px -1px 0px #730aa2, inset 0px 1px 0px #ce78f3;
            }
            &.lightup {
              background: linear-gradient(180deg, #28d4fe 0%, #4870ff 75.52%);
              box-shadow: 0px 0px 8px rgba(78, 173, 241, 0.5),
                inset 0px -1px 0px rgba(58, 154, 255, 0.7),
                inset 0px 1px 0px rgba(173, 237, 255, 0.5);
            }

            .typeName {
              // margin-top: 18px;
              // margin-left: 20px;
              width: 40px;
              height: 20px;
              text-align: center;
              line-height: 20px;
              background: rgba(255, 255, 255, 0.4);
              border-radius: 4px;
              font-weight: 600;
              font-size: 12px;
              margin-bottom: 10px;

              &.lucky ,&.turntable,&.jiugongge,&.niudanji,&.zhuabaoxiang,&.laohuji{
                color: #e94d26;
                &3 {
                  color: #fe5555;
                }
              }
              &.blindbox{
                color: #e94d26;
                &3{
                  color:#FE5555;
                }
                &4{
                  color:#007E94;
                }
                &5 {
                  color: #744AEC;
                }
              }
              &.coupon,
              &.purchase {
                color: #e15269;
                &0 {
                  color: #e15269;
                }
                &1 {
                  color: #e990ff;
                }
                &2 {
                  color: #188ff2;
                }
                &3 {
                  background: #F8E8B1;
                  color: #F74152;
                }
              }
              &.assistance {
                color: #920bd2;
              }
              &.lightup {
                color: #135dcb;
              }
            }

            .couponTitle {
              font-weight: 500;
              font-size: 18px;
              line-height: 24px;
              color: #ffffff;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 180px;
            }

            .couponInfo {
              width: 180px;
              font-size: 12px;
              line-height: 16px;
              margin-top: 2px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              &.lucky,&.turntable,&.jiugongge,&.niudanji,&.zhuabaoxiang,&.laohuji{
                color: #f2d5ab;
                &3 {
                  color: #cef7ea;
                }
              }
              &.blindbox{
                color: #f2d5ab;
                &3 {
                  color: #cef7ea;
                }
                &4 {
                  color: #D9FCEF;
                }
                &5 {
                  color: #CEF7EA;
                }
              }
              &.coupon,
              &.purchase {
                color: #ffe68e;
                &0 {
                  color: #ffe68e;
                }
                &1 {
                  color: #ffedad;
                }
                &2 {
                  color: #b5fcfe;
                }
                &3 {
                  color: #D9FCEF;
                }
              }
              &.assistance {
                color: #f1b4fb;
              }
              &.lightup {
                color: #ade3fe;
              }
            }
          }

          .itemIntro {
            width: 96px;
            margin: 10px 0 10px -60px;
            border-radius: 0 6px 6px 0;
            padding: 5px 5px 5px 2px;
            &.lucky , &.turntable,&.jiugongge,&.niudanji,&.zhuabaoxiang,&.laohuji{
              background: #ffecd1;
              box-shadow: 2px 0px 2px rgba(92, 60, 30, 0.3),
                inset 1px 0px 2px rgba(99, 26, 10, 0.4);
            }
            &.blindbox{
              background: #ffecd1;
              box-shadow: 2px 0px 2px rgba(92, 60, 30, 0.3), inset 1px 0px 2px rgba(99, 26, 10, 0.4);
              &4{
                background: #ECFFFD;
                box-shadow: 2px 0px 2px rgba(81, 151, 167, 0.5), inset 1px 0px 2px rgba(122, 179, 198, 0.5);
              }
              &5 {
                background: #FEFCFF;
                box-shadow: 2px 0px 2px rgba(156, 143, 238, 0.5), inset 1px 0px 2px #B293FF;
              }
            }
            &.coupon,
            &.purchase {
              background: #ffecd1;
              box-shadow: 2px 0px 2px rgba(92, 60, 30, 0.3),
                inset 1px 0px 2px rgba(99, 26, 10, 0.4);
                &0 {
                  background: #ffecd1;
                  box-shadow: 2px 0px 2px rgba(92, 60, 30, 0.3),
                    inset 1px 0px 2px rgba(99, 26, 10, 0.4);
                }
                &1 {
                  background: #f5f1ff;
                  box-shadow: 2px 0px 2px rgba(92, 60, 30, 0.3),
                    inset 1px 0px 2px rgba(99, 26, 10, 0.4);
                }
                &2 {
                  background: #fff7ec;
                  box-shadow: 2px 0px 2px rgba(24, 143, 242, 0.3),
                    inset 1px 0px 2px rgba(23, 127, 205, 0.4);
                }
                &3 {
                  background: #FFF1E3;
                  box-shadow: 2px 0px 2px rgba(167, 129, 81, 0.5),
                    inset 1px 0px 2px rgba(198, 172, 122, 0.5);
                }
            }
            &.assistance {
              background: #fff4e6;
              box-shadow: 2px 0px 2px rgba(92, 60, 30, 0.3),
                inset 1px 0px 2px rgba(99, 26, 10, 0.4);
            }
            &.lightup {
              background: #e8edf0;
              box-shadow: 2px 0px 2px rgba(81, 118, 167, 0.5),
                inset 1px 0px 2px rgba(122, 161, 198, 0.5);
            }
            .itemIntroBox {
              flex: 1;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              // margin:
              width: 100%;
              height: 100%;
              border: 1px solid #f1ceb6;
              border-left: none;
              box-sizing: border-box;
              border-radius: 2px;
              &.purchase {
                &1 {
                  border-color: #cfceff;
                }
                &2 {
                  border-color: #a4c9dd;
                }
                &3 {
                  border-color: #FEE1B6;
                }
              }
              &.blindbox{
                &4 {
                  border-color: #B9E9EC;
                }
                &5 {
                  border-color: #AF76FF;
                }
              }
            }

            .discount,
            .reduce {
              font-size: 12px;
              &.lucky, &.turntable,&.jiugongge,&.niudanji,&.zhuabaoxiang,&.laohuji{
                color: #e94d26;
                &3 {
                  color: #fe5555;
                }
              }
              &.blindbox{
                color: #e94d26;
                &3 {
                  color:#FE5555;
                }
                &4 {
                  color:#007E94;
                }
                &5 {
                  color: #FA80F3;
                }
              }
              &.coupon {
                color: #e15269;
              }
              &.purchase {
                color: #e15269;
                &0 {
                  color: #e15269;
                }
                &1 {
                  color: #e990ff;
                }
                &2 {
                  color: #188ff2;
                }
                &3 {
                  color: #F74152;
                }
              }
              &.assistance {
                color: #723db6;
              }
              &.lightup {
                color: #135dcb;
              }
              span {
                font-family: DIN Alternate;
                font-style: normal;
                font-weight: bold;
                font-size: 32px;
              }
            }

            .receive {
              width: 80px;
              height: 24px;
              margin-top: 5px;
              border-radius: 12px;
              font-weight: 500;
              font-size: 12px;
              line-height: 24px;
              color: #ffffff;
              text-align: center;
              &.lucky ,  &.turntable,&.jiugongge,&.niudanji,&.zhuabaoxiang,&.laohuji{
                background: #ee7e31;
                &3 {
                  background: #fe5555;
                }
              }
              &.blindbox{
                background: #ee7e31;
                &3 {
                  background: #FE5555;
                }
                &4 {
                  background: #007E94;
                }
                &5 {
                  background: #FA80F3;
                }
              }
              &.coupon {
                background: #e15269;
              }
              &.purchase {
                background: #e15269;
                &0 {
                  background: #e15269;
                }
                &1 {
                  background: #e990ff;
                }
                &2 {
                  background: #188ff2;
                }
                &3 {
                  background: #F74152;
                }
              }
              &.assistance {
                background: #723db6;
              }
              &.lightup {
                background: #135dcb;
              }
            }
          }
        }
      }
    }
  }
}
</style>
